import React, { Component } from 'react';
import { GithubPicker } from 'react-color';
import PubNubReact from 'pubnub-react';
import './App.css';
import inspect from 'util-inspect';
import QRCode from 'qrcode.react';

class App extends Component {
  constructor(props) {
    super(props);

    // derive channel name from query string
    const parts = window.location.href.split("?");
    this.channel =  (parts && parts[1]) || 'default';

    // random userid
    this.userId = "user" + (Math.random(1000));

    this.state = {
      background: '#000',
    };

    this.pubnub = new PubNubReact({
      publishKey: 'pub-c-2884742e-59f2-4ced-b9c5-3536de2768f5',
      subscribeKey: 'sub-c-963bd4b0-e461-11e8-bf53-0a39541862c0',
      uuid: this.userId
    });
    this.pubnub.init(this);
  }

  picker = null;

  register = value => {
    this.picker = value;
  }

  componentWillMount() {
    this.pubnub.subscribe({
      channels: [this.channel],
      withPresence: true
    });

    this.pubnub.getMessage(this.channel, (data) => {
      this.setState(() => {
        return { background: data.message.color };
      });
    });

    this.pubnub.getStatus((st) => {
      // user joined
    });
  }

  componentWillUnmount() {
    this.pubnub.unsubscribe({
      channels: [this.channel]
    });
  }

  handle1 = color => {
    const message = {
      action: 'colorChange',
      color: color.hex
    };

    this.pubnub.publish({
      message: message,
      channel: this.channel
    });
  }

  handle2 = color => {
    this.setState(() => {
      return { background: color.hex };
    });
  };

  render() {
    return (
      <div id="App" className="App" flex={1}>
        <header className="App-header" style={{ background: this.state.background }}>
          <QRCode value={window.location.href} style={{width:"300px",height:"300px"}} />
          <div>{this.state.background}</div>
          <GithubPicker
            ref={(_) => { this.picker = _; }}
            triangle={'hide'}
            color={this.state.background}
            onChange={this.handle1}
            onChangeComplete={this.handle2}
          />
        </header>
      </div>
    );
  }
}

export default App;
